angular.module('mercury.modules.reports.multisite')
.config(["$stateProvider", function($stateProvider) {
  $stateProvider.state('Reports.MultisiteOverview', {
    url: '/multisite/overview?report&compare',
    templateUrl: 'modules/reports/multisite/overview.tpl.html',
    controller: 'ReportsMultisiteOverviewCtrl'
  });

  $stateProvider.state('Reports.MultisiteSales', {
    url: '/multisite/sales?report&compare',
    templateUrl: 'modules/reports/multisite/sales.tpl.html',
    controller: 'ReportsMultisiteSalesCtrl'
  });

  $stateProvider.state('Reports.MultisiteCategories', {
    url: '/multisite/categories?report&compare',
    templateUrl: 'modules/reports/multisite/categories.tpl.html',
    controller: 'ReportsMultisiteCategoriesCtrl'
  });

  $stateProvider.state('Reports.MultisiteDiscounts', {
    url: '/multisite/discounts?report&compare',
    templateUrl: 'modules/reports/multisite/discounts.tpl.html',
    controller: 'ReportsMultisiteDiscountsCtrl'
  });

  $stateProvider.state('Reports.MultisiteReconciliations', {
    url: '/multisite/reconciliations?report&compare',
    templateUrl: 'modules/reports/multisite/reconciliation.tpl.html',
    controller: 'ReportsMultisiteReconciliationCtrl'
  });

  $stateProvider.state('Reports.MultisiteItems', {
    url: '/multisite/items?report&compare',
    templateUrl: 'modules/reports/multisite/items.tpl.html',
    controller: 'ReportsMultisiteItemsCtrl'
  });

  $stateProvider.state('Reports.MultisitePurchases', {
    url: '/multisite/purchases?report&compare',
    templateUrl: 'modules/reports/multisite/purchases.tpl.html',
    controller: 'ReportsMultisitePurchasesCtrl'
  });

  $stateProvider.state('Reports.MultisiteWageGroups', {
    url: '/multisite/wagegroups?report&compare',
    templateUrl: 'modules/reports/multisite/wagegroups.tpl.html',
    controller: 'ReportsMultisiteWageGroupsCtrl'
  });

  $stateProvider.state('Reports.MultisiteWageRoster', {
    url: '/multisite/wageroster?report&compare',
    templateUrl: 'modules/reports/multisite/wageroster.tpl.html',
    controller: 'ReportsMultisiteWageRosterCtrl'
  });
}]);
